/** @format */
import dataUtils from './dataUtils';

export default {
  mixins: [dataUtils],
  methods: {
    getOptions(model) {
      //this.$root.makedirs([model]);
      let res = [];
      if (model && model.options) {
        //  return model.options;
        if (Array.isArray(model.options)) {
          res = model.options.map((item) => {
            if (typeof item === 'string')
              return {
                text: item,
                value: item,
                isActive: true,
              };
            else return item;
          });
          //console.log('get options ', model.name, res, model.options);
          return res;
        }
        model.options.split(',').forEach((o) => {
          let r = [];
          if (o.includes('config11.')) {
            r = this.getFromConfig(o);
          }
          if (o.includes('config.') || o.includes('models.')) {
            r = this.getFromConfig(o);
          } else r = this.$root.config.meta.enum[o] || this.$root[o] || this.$store.state.config.data.config.dictionary?.[o] || [];
          res = [...res, ...(JSON.parse(JSON.stringify(r)) || [])];
        });
        return res;
      }
      if (model && model.field) {
        if (this.values[model.field]) return JSON.parse(this.values[model.field]);
      }

      if (model && model.dir) {
        let name_dir = model.dir;
        let filter_dir = model?.dirFilter || null;
        let dir = this.getFromDir(name_dir, filter_dir);
        return dir;
      }
      if (model && model.dirVar) {
        const key = model.dirVar.key;
        let dir = [];
        if (this.values) {
          const v = model?.json ? this.values?.data?.[key] : this.values[key];
          const dirConf =
            model.dirVar.dirName.find((el) => {
              return el.value == v;
            }) || {};
          let name_dir = dirConf?.name;
          let filter_dir = dirConf?.dirFilter || '';
          if (name_dir) {
            dir = this.getFromDir(name_dir, filter_dir);
          }
        }
        return dir;
      }
    },
    getFromConfig(p) {
      const config = Object.assign({}, this.$store.getters['config/get'] || {});
      //const config = this.$store.getters['config/get'] || {};

      let res = this.getObjectPath(config, p);
      //console.log('getFromConfig', p, res);
      let tmp;

      return res;
    },
    getFromConfig_(p) {
      let res = [];
      let tmp;

      const path = p.split('.');
      for (let i = 0; i < path.length; i++) {
        const el = path[i];
        if (i === 0) {
          tmp = JSON.parse(JSON.stringify(this.$store.getters['config/get'] || {}));
        }
        if (el !== 'config') {
          tmp = JSON.parse(JSON.stringify(tmp?.[el] || tmp));
        }

        if (el == 'docTable') tmp['AccountingDirContract'] = { name: 'Договора' };
      }
      for (const key in tmp) {
        if (Object.hasOwnProperty.call(tmp, key)) {
          const el = tmp[key];
          const row = { value: key, text: el.name };
          res.push(row);
        }
      }

      return res;
    },
  
    getFromDir(name, filter = '', text = '') {
      //    this.waitDir(name);
     
      const dir = (this.$dir.get(name) || []).map((item) => ({ ...item }));
      //     const dir = JSON.parse(JSON.stringify(this.$root.$dirs?.[name] || []));
      if (filter) {
        return dir.filter((el) => {
          let res = false;
          if (el)
            for (const key in filter) {
              //console.log('filter by ', key, filter[key], el?.[key]);
              if (key == 'formula') {
                let func;
                if (typeof filter.formula == 'function') func = filter.formula;
                if (typeof filter.formula == 'string') func = eval(filter.formula);
                res = func(el);
              } else if (Array.isArray(filter[key])) {
                if (filter[key].includes(el?.[key])) res = true;
              } else if (filter[key] === '%null') {
                res = el?.[key] === null;
              } else if (filter[key] === '%notNull') {
                res = el?.[key] !== null;
              } else {
                if (el?.[key] == filter[key]) {
                  res = true;
                } else {
                  res = false;
                }
              }
              if (res == false) return false;
            }
          return res;
        });
      } else {
        return dir;
      }
    },
    getFilterOptions(model) {
      if (model && model.search) {
        if (Array.isArray(model.search)) return model.search;
      }
      if (model && model.options) {
        let res;
        if (Array.isArray(model.options)) {
          res = model.options;
        } else {
          res = this.$root.config.meta.enum[model.options] || this.$root[model.options] || this.$store.state.config.data.config.dictionary?.[model.options] || [];
        }
        if (model.optionsFilter) {
          let f = model.optionsFilter;
          if (typeof f === 'string') {
            f = f.split(',');
          }
          if (f) return res.filter((r) => r.value !== null).filter((r) => f.includes(r.value.toString()));
        }
        return res;
      }
      if (model && model.dir) {
        let name_dir = model.dir;
        let filter_dir = model?.dirFilter || '';
        let text = model?.preText || '';
        let dir = this.getFromDir(name_dir, filter_dir, text);
        return dir;
      }
      if (model && model.dirVar) {
        const key = model.dirVar.key;
        let dir = [];
        for (const dirName of model.dirVar.dirName) {
          let name_dir = dirName.name;
          let filter_dir = dirName?.dirFilter || '';
          let text = dirName?.preText || '';
          let d = this.getFromDir(name_dir, filter_dir, text);
          d.forEach((el) => {
            if (text) {
              el.text = text + el.text;
            }
            if (dirName?.field) {
              el.value = el.value + '##' + dirName.field;
              el.field = dirName.field;
            }
          });

          dir = [...dir, ...d];
        }
        return dir;
      }
    },
    getElementByValue(value, model) {
      let options = this.getOptions(model);
      if (options) {
        return options.find((x) => x && x.value == value) ? options.find((x) => x && x.value == value) : {};
      }
    },
    getTextByValue(value, model) {
      if (model?.aliace) {
        value = this.values?.[model.aliace] || value;
      }
      let field = model.textField || 'text';
      let text = this.getElementByValue(value, model);
      return text?.[field] ? text[field] : value;
      return text?.text ? text.text : this.$t('none');
    },
    filterItems(d) {
      if (this.model.optionsFilter) {
        let filter = this.model.optionsFilter;
        d.forEach((el) => {
          let res = false;
          for (const key in filter) {
            let f = filter[key];
            if (typeof f == 'string' && f.includes('function(')) {
              try {
                f = eval(f);
              } catch (error) {}
            }
            if (Array.isArray(f)) {
              if (f.includes(el?.[key])) res = true;
            } else if (typeof f === 'function') {
              res = f(el[key], el, this.values);
            } else if (typeof f === 'string' && f.includes('bit#')) {
              let bit = f.split('#')[1];
              res = el[key] & (1 << (bit - 1));
            } else if (el?.[key] == f) res = true;
          }
          el.disabled = !res;
          el.isActive = res;
        });
      }

      return d;
    },
  },
};
